<template>
  <div ref="main" :style="divStyle"></div>
</template>

<script>
import * as echarts from 'echarts';
import dark from '@/theme/dark.json';
echarts.registerTheme('dark', dark);

export default {
  props: ['option', 'divStyle', 'notMerge'],
  mounted() {
    this.$nextTick(() => {
      this.chart = echarts.init(this.$refs.main, 'dark');
      if (this.option) {
        this.chart.setOption(this.option);
      }
    });
  },
  watch: {
    option() {
      this.chart.setOption(this.option, this.notMerge);
    }
  }
};
</script>
